import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft } from 'lucide-react';

export const MobilePageTransition = ({ 
  children, 
  show, 
  onClose, 
  title, 
  isDarkMode,
  hideHeader = false,
  rightButton,
  disableSafeAreaInset = false
}) => {
  if (!show) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ x: '100%' }}
          animate={{ x: 0 }}
          exit={{ x: '100%' }}
          transition={{ type: 'spring', bounce: 0, duration: 0.4 }}
          className={`fixed inset-0 z-50 flex flex-col ${isDarkMode ? 'bg-[#0A0A0A]' : 'bg-gray-50'}`}
        >
          {!hideHeader && (
            <header className={`sticky top-0 px-4 z-50 ${isDarkMode ? 'bg-[#0A0A0A]' : 'bg-gray-50'}`}>
              <div className="safe-area-padding">
                <div
                  style={
                    disableSafeAreaInset
                      ? { paddingTop: '1rem' }
                      : { paddingTop: 'calc(env(safe-area-inset-top) + 1rem)' }
                  }
                  className="py-4"
                >
                  <div className="relative flex items-center justify-center">
                    <div className="absolute left-0 top-1/2 -translate-y-1/2">
                      <button 
                        onClick={onClose} 
                        className={`flex items-center ${
                          isDarkMode ? 'text-emerald-400' : 'text-emerald-600'
                        }`}
                      >
                        <ChevronLeft className="w-5 h-5" />
                        <span className="text-xl">Back</span>
                      </button>
                    </div>
                    <h1 className={`text-xl font-semibold text-center ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`} style={{ margin: 0 }}>
                      {title}
                    </h1>
                    {rightButton && (
                      <div className="absolute right-0 top-1/2 -translate-y-1/2">
                        <button
                          onClick={rightButton.onClick}
                          className={`${
                            isDarkMode ? 'text-emerald-400' : 'text-emerald-600'
                          } text-xl`}
                        >
                          {rightButton.text}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </header>
          )}
          <div className="flex-1 overflow-y-auto" style={{ WebkitOverflowScrolling: 'touch' }}>
            <div className="px-4 pb-24">
              {children}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}; 